import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isInactivePlan: false,
  isTrialPlan: false,
};
const planSlice = createSlice({
  name: 'planSlice',
  initialState,
  reducers: {
    updatePlanState: (state, action) => {
      if (action.payload.isInactivePlan !== undefined) {
        state.isInactivePlan = action.payload.isInactivePlan;
      }

      if (action.payload.isTrialPlan !== undefined) {
        state.isTrialPlan = action.payload.isTrialPlan;
      }
    },
  },
});

export const { updatePlanState } = planSlice.actions;
export default planSlice.reducer;
